/**
 * Recipe Article JavaScript
 * Handles interactivity for recipe article pages
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize recipe functionality
  initIngredientCheckboxes();
  initSocialSharing();
  initPrintRecipe();
  initSmoothScroll();
});

/**
 * Handle ingredient checkbox interactions
 */
function initIngredientCheckboxes() {
  const checkboxes = document.querySelectorAll('.recipe-detail__checkbox');
  
  checkboxes.forEach(checkbox => {
    // Load saved state from localStorage
    const ingredientId = checkbox.id;
    const savedState = localStorage.getItem(`recipe-${window.location.pathname}-${ingredientId}`);
    
    if (savedState === 'checked') {
      checkbox.checked = true;
    }
    
    // Save state on change
    checkbox.addEventListener('change', function() {
      const key = `recipe-${window.location.pathname}-${ingredientId}`;
      if (this.checked) {
        localStorage.setItem(key, 'checked');
      } else {
        localStorage.removeItem(key);
      }
    });
  });
  
  // "Clear All" button functionality removed
  // const ingredientsList = document.querySelector('.recipe-detail__ingredients-list');
  // if (ingredientsList && checkboxes.length > 0) {
  //   const clearButton = document.createElement('button');
  //   clearButton.className = 'recipe-detail__clear-btn';
  //   clearButton.textContent = 'Clear All';
  //   clearButton.style.cssText = `
  //     margin-top: 1rem;
  //     padding: 0.5rem 1rem;
  //     background: transparent;
  //     border: 2px solid #8BC34A;
  //     color: #8BC34A;
  //     border-radius: 20px;
  //     cursor: pointer;
  //     font-weight: 600;
  //     transition: all 0.3s ease;
  //   `;
  //   
  //   clearButton.addEventListener('click', function() {
  //     checkboxes.forEach(checkbox => {
  //       checkbox.checked = false;
  //       const key = `recipe-${window.location.pathname}-${checkbox.id}`;
  //       localStorage.removeItem(key);
  //     });
  //   });
  //   
  //   clearButton.addEventListener('mouseenter', function() {
  //     this.style.background = '#8BC34A';
  //     this.style.color = 'white';
  //   });
  //   
  //   clearButton.addEventListener('mouseleave', function() {
  //     this.style.background = 'transparent';
  //     this.style.color = '#8BC34A';
  //   });
  //   
  //   ingredientsList.parentNode.appendChild(clearButton);
  // }
}

/**
 * Enhanced social sharing with tracking
 */
function initSocialSharing() {
  const shareButtons = document.querySelectorAll('.recipe-detail__share-btn');
  
  shareButtons.forEach(button => {
    if (button.tagName === 'A') {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const url = this.href;
        const network = this.className.split('--')[1];
        
        // Open in popup window
        window.open(
          url,
          `share-${network}`,
          'width=600,height=400,scrollbars=no,resizable=yes'
        );
        
        // Track share event if analytics available
        if (typeof gtag !== 'undefined') {
          gtag('event', 'share', {
            method: network,
            content_type: 'recipe',
            item_id: window.location.pathname
          });
        }
      });
    }
  });
}

/**
 * Print functionality for recipes - REMOVED
 * The print button has been disabled as requested
 */
function initPrintRecipe() {
  // Print button functionality removed
  // const shareSection = document.querySelector('.recipe-detail__share');
  // if (shareSection) {
  //   const printButton = document.createElement('button');
  //   printButton.className = 'recipe-detail__print-btn';
  //   printButton.innerHTML = `
  //     <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
  //       <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/>
  //     </svg>
  //     <span>Print Recipe</span>
  //   `;
  //   
  //   printButton.style.cssText = `
  //     display: inline-flex;
  //     align-items: center;
  //     gap: 0.5rem;
  //     margin-left: 1rem;
  //     padding: 0.625rem 1.25rem;
  //     background: #666;
  //     color: white;
  //     border: none;
  //     border-radius: 25px;
  //     cursor: pointer;
  //     font-weight: 600;
  //     transition: all 0.3s ease;
  //   `;
  //   
  //   printButton.addEventListener('click', function() {
  //     window.print();
  //   });
  //   
  //   printButton.addEventListener('mouseenter', function() {
  //     this.style.background = '#333';
  //     this.style.transform = 'translateY(-2px)';
  //   });
  //   
  //   printButton.addEventListener('mouseleave', function() {
  //     this.style.background = '#666';
  //     this.style.transform = 'translateY(0)';
  //   });
  //   
  //   shareSection.appendChild(printButton);
  // }
}

/**
 * Smooth scroll for anchor links
 */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

/**
 * Add print-specific styles
 */
const printStyles = document.createElement('style');
printStyles.innerHTML = `
  @media print {
    .recipe-hero-article__breadcrumbs,
    .recipe-detail__share,
    .recipe-detail__print-btn,
    .recipe-detail__clear-btn,
    .recipe-related-grid,
    footer {
      display: none !important;
    }
    
    .recipe-hero-article {
      min-height: auto !important;
      height: auto !important;
    }
    
    .recipe-hero-article__container {
      height: auto !important;
    }
    
    .recipe-hero-article__title {
      color: #333 !important;
      text-shadow: none !important;
    }
    
    .recipe-detail__columns {
      display: block !important;
    }
    
    .recipe-detail__ingredients,
    .recipe-detail__instructions {
      page-break-inside: avoid;
      margin-bottom: 2rem;
    }
    
    .recipe-detail__checkbox {
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }
  }
`;
document.head.appendChild(printStyles);